export default "__VITE_ASSET__Ed3y2e1M__"